module.exports = __webpack_public_path__ + "static/media/LeFruitier.656cd872.png";